import { gql } from "@apollo/client";

export default gql`
  mutation updateCustomerOnboardingInfo($data: UpdateCOnboardingInfoInput!){
    updateCustomerOnboardingInfo(data: $data){
        success
        data{
            _id
            customer
            companyName
            companyWebsite
            howBuiltWebsite
            companySize
            companyIndustry
            ownerRole
            favouriteProducts
            howYouHearAboutUs
            country
            language
            sector
            sectorOther
            teamSize
            monthlyVolume
            channels
            platform
            platformOther
            source
            sourceOther
            aiInterest
        }
        code
        message
    }
}
`
